export const environment = {
  environmentName: 'test',
  production: false,
  authMode: 'bff',
  backend: {
    baseUrl: '',
    apiUrl: '/api',
  },
  identity: {
    ciamTenantId: 'e1e712ff-4188-4cad-8944-02d8934c0743'
  },
  appInsights: {
    instrumentationKey: '',
  },
  // MSAL configuration for employee authentication
  msal: {
    clientId: '6a4f1159-90de-4f60-a02a-ccdb51810c23', // Nlc-Frontend-Test
    authority: 'https://login.microsoftonline.com/899780ab-82ce-4584-8742-3e870500bb0f',
    redirectUri: 'https://test.nlc.niclen.de/redirect',
    scopes: ['openid', 'profile', 'email'],
    apiScopes: ['api://0efbd594-10b2-4a51-b131-ae08f24f34a0/access_as_user'] // Replace with your backend API scope
  },
  // MSAL configuration for customers (CIAM)
  msalCustomer: {
    clientId: 'e661774c-f964-4df8-83b0-cb600ddfe309', // same as local config
    authority: 'https://niclenkunden.ciamlogin.com/e1e712ff-4188-4cad-8944-02d8934c0743/v2.0',
    knownAuthorities: ['e1e712ff-4188-4cad-8944-02d8934c0743.ciamlogin.com'],
    redirectUri: 'https://test.nlc.niclen.de/redirect',
    scopes: ['openid', 'profile', 'email'],
    apiScopes: ['api://c9a84929-77db-41f9-936c-93085893b94e/customer.own.access']
  },
  // App registration for frontend to backend authentication
  // appRegistration removed (no longer used)
};
